import { render, staticRenderFns } from "./CaseAdd.vue?vue&type=template&id=e86888f2&scoped=true&"
import script from "./CaseAdd.vue?vue&type=script&lang=js&"
export * from "./CaseAdd.vue?vue&type=script&lang=js&"
import style0 from "./CaseAdd.vue?vue&type=style&index=0&id=e86888f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86888f2",
  null
  
)

export default component.exports